<template>
  <div class="row map-printing-options">
    <div class="col-8">
      <div class="map-printing-map">
        <div id="mapPrinting" style="height: 500px;"></div>
        <PlotSelection ref="PlotSelection" :printingMap="map" />
      </div>
    </div>

    <div class="col-4">
      <form>
        <div class="form-row">
          <div class="col">
            <label>{{ $t("mapprinting.format") }}</label>
          </div>
          <div class="col">
            <multiselect
              class="map-printing-select"
              v-model="FormatSizeSelected"
              :options="FormatSizeValue"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              open-direction="bottom"
              id="format"
              ref="format"
            ></multiselect>
          </div>
        </div>

        <div class="form-row">
          <div class="col">
            <label>{{ $t("mapprinting.dpi") }}</label>
          </div>
          <div class="col">
            <multiselect
              class="map-printing-select"
              v-model="ResolutionSelected"
              :options="ResolutionValue"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              open-direction="bottom"
              id="resolution"
              ref="resolution"
            ></multiselect>
          </div>
        </div>
      </form>

      <div class="map-printing-vuebar" v-bar>
        <div>
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="GPSCoordinates"
              v-model="printGpsCoords"
            />
            <label class="custom-control-label" for="GPSCoordinates">{{ $t("mapprinting.gps") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="Legend" v-model="printLegend" />
            <label class="custom-control-label" for="Legend">{{ $t("mapprinting.legend") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="Scale" v-model="printScale" />
            <label class="custom-control-label" for="Scale">{{ $t("mapprinting.scale") }}</label>
          </div>

          <div class="map-printing-title">
            <span>{{ $t("mapprinting.maps") }}</span>
          </div>

          <div
            class="custom-control custom-radio"
            v-for="(item, idx) of $parent.$parent.basemapLayers"
            :key="`mapPrinitngLayersBasemap${idx}`"
          >
            <input
              type="radio"
              class="custom-control-input"
              :id="`mapPrinitngLayersBasemap${idx}`"
              :value="item.name"
              v-model="$parent.$parent.basemap"
            />
            <label
              class="custom-control-label"
              :for="`mapPrinitngLayersBasemap${idx}`"
            >{{ $t(`legend.${item.name}`) }}</label>
          </div>

          <div class="map-printing-title">
            <span>{{ $t("legend.record") }}</span>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingNr"
              v-model="$parent.$parent.activeLayers.dzialki"
              @click.stop="$parent.$parent.toggleLayer('dzialki-layer', $event)"
            />
            <label class="custom-control-label" for="mapPrintingNr">{{ $t("legend.surface") }}</label>
          </div>

          <div class="map-printing-title">
            <span>{{ $t("mapprinting.infrastructure") }}</span>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingEnergy"
              v-model="$parent.$parent.activeLayers.media.prad"
            />
            <label
              class="custom-control-label"
              for="mapPrintingEnergy"
            >{{ $t("mapprinting.energy") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingWater"
              v-model="$parent.$parent.activeLayers.media.woda"
            />
            <label class="custom-control-label" for="mapPrintingWater">{{ $t("mapprinting.water") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingSewer"
              v-model="$parent.$parent.activeLayers.media.sanit"
            />
            <label class="custom-control-label" for="mapPrintingSewer">{{ $t("mapprinting.sewer") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingGas"
              v-model="$parent.$parent.activeLayers.media.gaz"
            />
            <label class="custom-control-label" for="mapPrintingGas">{{ $t("mapprinting.gas") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingTeltech"
              v-model="$parent.$parent.activeLayers.media.telekom"
            />
            <label
              class="custom-control-label"
              for="mapPrintingTeltech"
            >{{ $t("mapprinting.teltech") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingRain"
              v-model="$parent.$parent.activeLayers.media.deszcz"
            />
            <label class="custom-control-label" for="mapPrintingRain">{{ $t("mapprinting.rain") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingConnection"
              v-model="$parent.$parent.activeLayers.media.connection"
            />
            <label
              class="custom-control-label"
              for="mapPrintingConnection"
            >{{ $t("mapprinting.connection") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingParking"
              v-model="$parent.$parent.activeLayers.media.parking"
            />
            <label
              class="custom-control-label"
              for="mapPrintingParking"
            >{{ $t("mapprinting.parking") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingRoads"
              v-model="$parent.$parent.activeLayers.media.roads"
            />
            <label class="custom-control-label" for="mapPrintingRoads">{{ $t("mapprinting.roads") }}</label>
          </div>

          <div class="map-printing-title">
            <span>{{ $t("mapprinting.categories") }}</span>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingAvailable"
              v-model="$parent.$parent.activeLayers.ficzery"
              @click.stop="$parent.$parent.toggleLayer('ficzery', $event)"
            />
            <label
              class="custom-control-label"
              for="mapPrintingAvailable"
            >{{ $t("legend.available") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingInvested"
              v-model="$parent.$parent.activeLayers.ficzeryZainwest"
              @click.stop="$parent.$parent.toggleLayer('ficzeryZainwest', $event)"
            />
            <label
              class="custom-control-label"
              for="mapPrintingInvested"
            >{{ $t("legend.invested") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingHalls"
              v-model="$parent.$parent.activeLayers.hale"
              @click="$parent.$parent.toggleLayer('hale-layer', $event);"
            />
            <label class="custom-control-label" for="mapPrintingHalls">{{ $t("legend.halls") }}</label>
          </div>

          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="mapPrintingOffices"
              v-model="$parent.$parent.activeLayers.biura"
              @click.stop="$parent.$parent.toggleLayer('biura-layer', $event)"
            />
            <label class="custom-control-label" for="mapPrintingOffices">{{ $t("legend.offices") }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="map-printing-navs">
        <b-button variant="link" @click="printMap">{{ $t("mapprinting.ok") }}</b-button>
        <b-button
          variant="link"
          data-dismiss="modal"
          aria-label="Close"
          @click="$modal.hide('modal-map-printing');"
        >{{ $t("mapprinting.cancel") }}</b-button>
      </div>
    </div>
    <img ref="logoPrint" style="display:none" src="/img/invest_park_logo_big.png" />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Map from "ol/Map";
import { defaults as defaultControls, ScaleLine } from "ol/control.js";
import { pointerMove } from "ol/events/condition.js";
import Select from "ol/interaction/Select.js";
import { Fill, Stroke, Style } from "ol/style.js";
import { transform, transformExtent } from "ol/proj.js";
import MultiPolygon from "ol/geom/MultiPolygon";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import Layers from "@/components/layers.js";

import PlotSelection from "./mapPrintingPlotSelection/PlotSelection";

export default {
  props: ["parentMap"],
  data: function() {
    return {
      map: undefined,
      FormatSizeSelected: "A4",
      FormatSizeValue: ["A4", "A3", "A2", "A1", "A0"],
      printGpsCoords: true,
      printLegend: true,
      printScale: true,
      scaleText: undefined,
      scaleWidth: undefined,
      // Wymiary podane w mm w przeciwieństwie do innych wymiarów w pdfmake
      A4: [297, 210],
      A3: [420, 297],
      A2: [594, 420],
      A1: [841, 594],
      A0: [1189, 841],

      ResolutionSelected: "75",
      ResolutionValue: ["75", "150", "300"],

      infrastructureLayers: Layers.infrastructureLayers,
      offersLayers: Layers.offersLayers,
      recordLayers: Layers.recordLayers,

      navData: this.$parent.$parent.$parent.$refs.nav.$data,

      wsseGrey: "#787677",
      wsseNavy: "#254665"
    };
  },
  components: {
    Multiselect,
    PlotSelection
  },
  computed: {
    currentItem() {
      return this.$store.getters.currentItem;
    }
  },
  methods: {
    getLayerByName(name) {
      return this.map
        .getLayers()
        .getArray()
        .filter(l => {
          return l.get("name") == name;
        })[0];
    },
    toggleLayer(name, event) {
      let lyr = this.getLayerByName(name);
      if (!lyr && event) {
        event.preventDefault();
        return;
      }
      lyr.setVisible(!lyr.getVisible());
    },
    printMap() {
      // Strona z wydrukiem mapy będzie podzielona w proporcjach
      // ~ 300 pt legendy i reszta dla mapy (o ile włączono
      // legendę do wydruku). Jednostki długości i szerokości
      // przeliczane na `pt` wg:
      // https://www.cl.cam.ac.uk/~mgk25/iso-paper-ps.txt
      // Wartości 72 w kodzie to wyjściowe DPI, względem którego
      // liczymy proporcje elementów na stronie.
      var dims = {
        A4: this.A4,
        A3: this.A3,
        A2: this.A2,
        A1: this.A1,
        A0: this.A0
      };

      for (let tool of this.map.getControls().array_) {
        if (tool instanceof ScaleLine) {
          this.scaleText = tool.innerElement_.innerText;
          this.scaleWidth = tool.innerElement_.clientWidth;
          break;
        }
      }

      document.body.style.cursor = "progress";

      var formatVar = this.$refs.format.value;
      var dim = dims[formatVar];
      let legendColumnWidth = 300; // jednostka - pt
      let marginWidth = this.mmToPt(10, 72); // 10 mm dla wyjściowego dpi 72

      let width = undefined;
      if (this.printLegend === true) {
        width = Math.round(this.mmToPt(dim[0] - 20, 72) - legendColumnWidth);
      } else {
        width = Math.round(this.mmToPt(dim[0] - 20, 72));
      }
      let height = Math.round(this.mmToPt(dim[1] - 20, 72));
      var size = this.map.getSize();
      var extent = this.map.getView().calculateExtent(size);
      var dataUri = this.getDataUri(this.$refs.logoPrint);
      let mapCenter = new transform(
        this.map.getView().getCenter(),
        "EPSG:3857",
        "EPSG:4326"
      );

      this.map.once("rendercomplete", event => {
        var canvas = event.context.canvas;
        let mapData = canvas.toDataURL();
        let [offers, totalArea] = this.offersList();

        let dd = {
          pageSize: formatVar,
          pageOrientation: "landscape",
          pageMargins: [marginWidth, marginWidth, marginWidth, marginWidth],
          content: [
            {
              columns: []
            }
          ],
          styles: {
            indent: {
              margin: [10, 0, 0, 0]
            },
            tableText: {
              fontSize: { A4: 10, A3: 13, A2: 18, A1: 24, A0: 28 }[formatVar]
            },
            gpsCoords: {
              color: this.wsseGrey
            }
          }
        };
        if (offers.length > 1) {
          // Stworzy tabelę na drugiej stronie, jeśli jakiekolwiek oferty są widoczne na mapie
          dd.content.push({
            pageBreak: "before",
            stack: [
              this.printLogo(dim, dataUri),
              {
                margin: [0, this.calcH(10, dim), 0, 0],
                text: "Dane ewidencyjne",
                alignment: "left",
                bold: true,
                color: this.wsseNavy,
                style: "tableText"
              },
              {
                margin: [0, this.calcH(5, dim), 0, 0],
                table: {
                  widths: this.tableWidths(dim),
                  body: offers
                }
              },
              {
                margin: [0, this.calcH(5, dim), 0, 0],
                text:
                  this.$t("mapprinting.totalArea") +
                  " " +
                  totalArea.toFixed(2).toString(),
                alignment: "right",
                bold: true,
                color: this.wsseNavy,
                style: "tableText"
              }
            ]
          });
        }
        if (this.printLegend === true) {
          // Do wydruku dołączana ma być legenda
          dd.content[0].columns = [
            {
              width: legendColumnWidth,
              stack: [
                this.printLogo(dim, dataUri),
                {
                  margin: [0, this.calcH(5, dim), 0, 0],
                  stack: [
                    // Kolejność zachowana jak w oknie wydruku
                    this.currentOffer(),
                    this.parcels(),
                    this.infrastructures(),
                    this.offers()
                  ]
                }
              ]
            },
            [
              {
                // Rozmiar obrazu jest wyliczony tak, żeby idealnie wypełniał resztę miejsca
                // na stronie. Ale jak jest "na styk", to obraz jest przenaszany na drugą
                // stronę, więc odejmujemy 1 pt. Tak samo dla mapy bez legendy
                image: mapData,
                width: width - 1
              },
              this.coordsAndScale(dim, mapCenter)
            ]
          ];
        } else {
          // Wydruk bez legendy
          dd.content[0].columns = [
            [
              {
                margin: [0, this.calcH(1, dim), 0, 0],
                image: mapData,
                width: width - 1
              },
              this.coordsAndScale(dim, mapCenter)
            ]
          ];
        }
        // pdfMake.createPdf(dd).open() // Otworz w nowej karcie
        pdfMake.createPdf(dd).download("Inwestor.pdf");

        // Po wydruku przywraca rozmiar mapy
        this.map.setSize(size);
        this.map.getView().fit(extent, { size: size });
        document.body.style.cursor = "auto";
      });

      // Ustawia rozmiar mapy do wydruku
      var printSize = [width, height];
      this.map.setSize(printSize);
      this.map.getView().fit(extent, { size: printSize });
    },
    printLogo(dim, dataUri) {
      // Logo i nazwa organizacji w lewym górnym rogu
      return {
        margin: [0, 0, 0, 0],
        columns: [
          {
            width: 50,
            stack: [{ image: dataUri, width: 50 }]
          },
          {
            margin: [0, 2, 0, 0], // z braku możliwości wyrównania w pionie, ręcznie dobrane jest przesunięcie = 2
            stack: [
              {
                text: "Wałbrzyska Specjalna Strefa Ekonomiczna",
                color: this.wsseNavy,
                fontSize: 11,
                bold: true,
                margin: [5, 0, 5, 0]
              },
              {
                text: "Wałbrzych Special Economic Zone",
                color: this.wsseGrey,
                fontSize: 11,
                bold: false,
                margin: [5, 0, 5, 0]
              }
            ]
          }
        ]
      };
    },
    prepareLayer(layer, symbol, title) {
      // Dodaje do legendy wiersz z daną warstwą
      return {
        margin: [10, 0, 0, 0],
        columns: [
          {
            width: 10,
            stack: [{ canvas: [symbol] }]
          },
          {
            margin: [5, 0, 0, 0],
            width: "*",
            text: this.$t(title)
          }
        ]
      };
    },
    sectionHeader(title) {
      // Nagłówek sekcji legendy z szarym punktem
      return {
        columns: [
          {
            margin: [0, 4, 0, 0],
            width: 10,
            stack: [{ canvas: [this.listBullet("grey")] }]
          },
          {
            width: "*",
            text: title
          }
        ]
      };
    },
    currentOffer() {
      // Zwraca informacje o aktualnie wybranej ofercie
      if (this.currentItem) {
        return [
          // Nazwa oferty
          this.sectionHeader(
            this.$t("mapprinting.header") +
              ": " +
              this.$options.filters.showInLang(
                this.currentItem.properties.nazwa,
                this.navData.currlang
              )
          ),
          {
            // Spacing
            text: " ",
            lineHeight: 1
          },
          this.sectionHeader(
            // Powierzchnia
            this.$t("nav.infoPanel.surface") +
              " " +
              this.$options.filters.showInLangField(
                this.currentItem.properties.powierzch,
                this.navData.currlang
              )
          ),
          {
            // Spacing
            text: " ",
            lineHeight: 1
          },
          this.sectionHeader(
            // Miejscowość
            this.$t("nav.infoPanel.city") +
              " " +
              this.$options.filters.showInLangField(
                this.currentItem.properties.miejscowosc,
                this.navData.currlang
              )
          ),
          {
            // Gmina
            text:
              this.$t("nav.infoPanel.community") +
              " " +
              this.$options.filters.showInLangField(
                this.currentItem.properties.gmina_nazwa,
                this.navData.currlang
              ),
            style: "indent"
          },
          {
            // Powiat
            text:
              this.$t("nav.infoPanel.district") +
              " " +
              this.$options.filters.showInLangField(
                this.currentItem.properties.powiat_nazwa,
                this.navData.currlang
              ),
            style: "indent"
          },
          {
            // Województwo
            text:
              this.$t("nav.infoPanel.voivodeship") +
              " " +
              this.$options.filters.showInLangField(
                this.currentItem.properties.wojewodztwo_nazwa,
                this.navData.currlang
              ),
            style: "indent"
          },
          {
            text: "",
            margin: [0, 10, 0, 0]
          }
        ];
      }
      return {};
    },
    parcels() {
      // Dodaje legendzie segment dot. działek ewidencyjnych, jeśli
      // są one włączone na mapie
      let rows = [];
      for (let l of this.recordLayers) {
        if (this.$parent.$parent.activeLayers[l.layerName] == true) {
          rows.push(
            this.prepareLayer(
              l.layerName,
              this.legendStyles(l.layerName),
              l.label
            )
          );
        }
      }
      if (rows.length < 1) {
        return {};
      }
      return {
        margin: [0, 10, 0, 0],
        stack: [this.sectionHeader(this.$t("legend.record")), rows]
      };
    },
    infrastructures() {
      // Dodaje legendzie segment dot. warstw infrastruktury, jeśli
      // jakaś jest włączona na mapie
      let rows = [];
      for (let l of this.infrastructureLayers) {
        if (this.$parent.$parent.activeLayers.media[l.layerName] == true) {
          rows.push(
            this.prepareLayer(
              l.layerName,
              this.legendStyles(l.layerName),
              l.label
            )
          );
        }
      }
      if (rows.length < 1) {
        return {};
      }
      return {
        margin: [0, 5, 0, 0],
        stack: [this.sectionHeader(this.$t("mapprinting.infrastructure")), rows]
      };
    },
    offers() {
      // Dodaje legendzie segment dot. ofert inwestycyjnych, jeśli
      // są one włączone na mapie
      let rows = [];
      for (let l of this.offersLayers) {
        if (this.$parent.$parent.activeLayers[l.layerName] == true) {
          rows.push(
            this.prepareLayer(
              l.layerName,
              this.legendStyles(l.layerName),
              l.label
            )
          );
        }
      }
      if (rows.length < 1) {
        return {};
      }
      return {
        margin: [0, 5, 0, 0],
        stack: [this.sectionHeader(this.$t("mapprinting.categories")), rows]
      };
    },
    offersList() {
      let headers = [];
      for (let header of [
        this.$t("mapprinting.voivodeship"),
        this.$t("mapprinting.district"),
        this.$t("mapprinting.community"),
        this.$t("mapprinting.city"),
        this.$t("mapprinting.precinct"),
        "Status",
        this.$t("mapprinting.owner"),
        this.$t("mapprinting.parcelNumber"),
        this.$t("mapprinting.surface")
      ]) {
        headers.push({
          text: header,
          bold: true,
          color: this.wsseNavy,
          style: "tableText"
        });
      }
      let [body, totalArea] = this.filterVisibleOffers();
      body.unshift(headers);
      return [body, totalArea];
    },
    listBullet(color) {
      // Dodaje kropkę o zadanym kolorze
      // z przesunięciem jak dla segmentu listy
      return {
        type: "ellipse",
        x: 0,
        y: 3,
        color: color,
        r1: 5,
        r2: 5
      };
    },
    shapeCircle(color) {
      // Dodaje kropkę o zadanym kolorze
      // z przesunięciem jak dla elementu legendy
      return {
        type: "ellipse",
        x: 5,
        y: 7,
        color: color,
        r1: 5,
        r2: 5
      };
    },
    shapeRect(border, inside) {
      // Dodaje kwadrat o zadanych kolorach
      return {
        type: "rect",
        x: 0,
        y: 3,
        w: 10,
        h: 10,
        r: 0,
        lineColor: border,
        color: inside
      };
    },
    shapeLine(color) {
      // Dodaje linię o zadanym kolorze. Tak naprawdę jest
      // to bardzo spłaszczony prostokąt
      return {
        type: "rect",
        x: 0,
        y: 6,
        w: 10,
        h: 1,
        r: 0,
        lineColor: color,
        color: color
      };
    },
    legendStyles(layername) {
      return {
        // Infrastruktura
        prad: this.shapeLine("#FD0504"),
        woda: this.shapeLine("#0B0BFC"),
        sanit: this.shapeLine("#7C661B"),
        gaz: this.shapeLine("#FDDA1D"),
        deszcz: this.shapeLine("#F900F9"),
        connection: this.shapeRect("#775F0E", "#775F0E"),
        parking: this.shapeRect("#313131", "#8C8C8C"),
        telekom: this.shapeLine("#9A57CD"),
        roads: this.shapeLine("#9A57CD"), // do zmiany
        // Dzialki ewidencyjne
        dzialki: this.shapeRect("#ff4040", "#ffffff"),
        // Oferty
        ficzery: this.shapeRect("#8899AA", "#8899AA"),
        ficzeryZainwest: this.shapeRect("#717171", "#E2E2E2"),
        hale: this.shapeRect("#7EB2BB", "#7EB2BB"),
        biura: this.shapeCircle("#7EB2BB")
      }[layername];
    },
    getDataUri(image) {
      // Zwraca obraz jako data URI string
      let canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0);
      return canvas.toDataURL();
    },
    calcW(size, d, legend) {
      // Oblicza szerokość zależną od formatu, wyjściowa propocja to A4
      // Wartość `legend` to przybliżona szerokość panelu legendy w
      // milimetrach, o ile wybrano legendę do druku.
      // 72 / 25.4 to https://www.cl.cam.ac.uk/~mgk25/iso-paper-ps.txt
      let widthA4 = ((297 - legend) * 72) / 25.4;
      let pageWidth = ((d[0] - legend) * 72) / 25.4;
      return (size * pageWidth) / widthA4;
    },
    calcH(size, d) {
      // Oblicza wysokość zależną od formatu, wyjściowa proporcja to A4
      // 72 / 25.4 to https://www.cl.cam.ac.uk/~mgk25/iso-paper-ps.txt
      return (size / 210) * ((d[1] * 72) / 25.4);
    },
    mmToPt(v, ppi) {
      // Konwertuje wartość w milimetrach na jednostkę pt
      // https://www.cl.cam.ac.uk/~mgk25/iso-paper-ps.txt
      return (v * ppi) / 25.4;
    },
    filterVisibleOffers() {
      // Zwraca wszystkie oferty inwestycyjne, które znajdują się
      // w obrębie bieżącego widoku mapy
      let visibleOffers = [];
      let totalArea = 0.0;

      let extent = new transformExtent(
        this.map.getView().calculateExtent(this.map.getSize()),
        "EPSG:3857",
        "EPSG:4326"
      );

      let offerFilter = this.$refs.PlotSelection.offerFilter;

      for (let offer of this.$parent.$parent.offersJSON.features) {
        // Intersect oferty z BBOXem
        let x = new MultiPolygon(offer.geometry.coordinates);
        if (x.intersectsExtent(extent) && offerFilter(offer)) {
          visibleOffers.push(
            this.rowOffer(
              offer,
              "#00820f",
              this.$t("mapprinting.areaAvailable")
            )
          );
          totalArea += offer.properties.powierzch;
        }
      }
      for (let offer of this.$parent.$parent.offersJSONZainwest.features) {
        // Intersect zainwestowanej oferty z BBOXem
        let x = new MultiPolygon(offer.geometry.coordinates);
        if (x.intersectsExtent(extent) && offerFilter(offer)) {
          visibleOffers.push(
            this.rowOffer(
              offer,
              "#ff0000",
              this.$t("mapprinting.areaUnavailable")
            )
          );
          totalArea += offer.properties.powierzch;
        }
      }
      return [visibleOffers, totalArea];
    },
    rowOffer(offer, color, text) {
      let row = [];
      for (let col of [
        offer.properties.wojewodztwo_nazwa,
        offer.properties.powiat_nazwa,
        offer.properties.gmina_nazwa.replace("gmina ", ""),
        offer.properties.miejscowosc,
        offer.properties.obreb,
        {
          text: text,
          color: color
        },
        offer.properties.wlasciciel,
        offer.properties.numery_dzialek.join(", "),
        offer.properties.powierzch
      ]) {
        row.push({
          text: this.$options.filters.showInLangField(
            col,
            this.navData.currlang
          ),
          style: "tableText"
        });
      }
      return row;
    },
    tableWidths(pageSize) {
      if (pageSize == this.A4) {
        return [70, 80, 80, "*", "*", 82, "*", "*", 70];
      } else if (pageSize == this.A3) {
        return [85, 85, 110, "*", "*", 110, "*", "*", 85];
      }
      return ["*", "*", "*", "*", "*", "*", "*", "*", "*"];
    },
    coordsAndScale(dim, mapCenter) {
      let stack = [];
      let buffer = this.printGpsCoords === true ? 2 : 1.5;

      if (this.printScale === true && this.scaleText != undefined) {
        let width = this.scaleWidth * 0.75; // * 0.75 to przeliczenie px -> pt
        let vertLine1 = {
          type: "line",
          x1: 0,
          y1: -3,
          x2: 0,
          y2: 3,
          lineWidth: 1
        };
        let mainLine = {
          type: "line",
          x1: 0,
          y1: 0,
          x2: width,
          y2: 0,
          lineWidth: 1
        };
        let vertLine2 = {
          type: "line",
          x1: width,
          y1: -3,
          x2: width,
          y2: 3,
          lineWidth: 1
        };
        stack.push(
          {
            canvas: [vertLine1, mainLine, vertLine2],
            absolutePosition: {
              x: this.mmToPt(10, 72),
              y: this.mmToPt(dim[1], 72) - buffer * this.mmToPt(10, 72)
            }
          },
          {
            text: this.scaleText,
            absolutePosition: {
              x: this.mmToPt(10, 72) + width + 5,
              y: this.mmToPt(dim[1], 72) - buffer * this.mmToPt(10, 72) - 8
            }
          }
        );
      }

      if (this.printGpsCoords === true) {
        stack.push({
          // Współrzędne środka mapy
          text:
            "X: " +
            mapCenter[0].toFixed(3) +
            "° Y: " +
            mapCenter[1].toFixed(3) +
            "°",
          style: "gpsCoords",
          absolutePosition: {
            x: this.mmToPt(10, 72),
            y: this.mmToPt(dim[1], 72) - 1.5 * this.mmToPt(10, 72)
          }
        });
      }

      return stack;
    }
  },
  mounted() {
    let scaleLineControl = new ScaleLine();
    this.map = new Map({
      layers: this.parentMap.getLayers(),
      target: "mapPrinting",
      view: this.parentMap.getView(),
      controls: defaultControls().extend([scaleLineControl])
    });
    this.map.on("singleclick", e => {
      var selected = this.map.getFeaturesAtPixel(e.pixel);
      if (selected) {
        selected = selected.filter(f => f.get("label") != true);
        if (this.getLayerByName("powiatyLayer").getVisible()) {
          this.$root.$emit("cartogramSelectPowiat", selected[0].get("nazwa"));
        } else if (this.getLayerByName("gminyLayer").getVisible()) {
          this.$root.$emit("cartogramSelectGmina", {
            gmina: selected[0].get("nazwa"),
            powiat: selected[0].get("powiat_nazwa")
          });
        }
      } else {
        this.$root.$emit("cartogramClearCollapse");
      }
    });
    let selectPointerMove = new Select({
      layers: [
        this.getLayerByName("powiatyLayer"),
        this.getLayerByName("gminyLayer")
      ],
      condition: pointerMove,
      style: feature => {
        let style = new Style({
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.3)"
          }),
          stroke: new Stroke({ color: "rgba(0, 0, 0, 0.6)", width: 0.3 })
        });
        let n_ofert = feature.get("n_ofert");
        if (n_ofert == undefined) {
          return style;
        }
        if (n_ofert == 0) {
          style.getFill().setColor("rgba(255, 255, 255, 0.3)");
        } else if (n_ofert == 1) {
          style.getFill().setColor("rgba(218, 227, 243, 0.6)");
        } else if (n_ofert == 2) {
          style.getFill().setColor("rgba(202, 214, 235, 0.6)");
        } else if (n_ofert >= 3 && n_ofert <= 4) {
          style.getFill().setColor("rgba(189, 203, 227, 0.6)");
        } else if (n_ofert >= 5 && n_ofert <= 6) {
          style.getFill().setColor("rgba(183, 198, 224, 0.6)");
        } else if (n_ofert >= 7 && n_ofert <= 8) {
          style.getFill().setColor("rgba(170, 187, 217, 0.6)");
        } else if (n_ofert >= 9 && n_ofert <= 12) {
          style.getFill().setColor("rgba(149, 170, 206, 0.6)");
        } else {
          style.getFill().setColor("rgba(47, 85, 151, 0.6)");
        }
        style.setStroke(
          new Stroke({ color: "rgba(0, 32, 96, 0.6)", width: 2 })
        );
        return style;
      }
    });
    this.map.addInteraction(selectPointerMove);
  }
};
</script>